import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				height: "100vh",
				position: "relative",
				backgroundColor: "white !important"
			},
			header: {
				position: "absolute",
				top: 0,
				backgroundColor: "white !important",
				width: "100%",
				height: 60,
				zIndex: 999
			},
			rootHeader: {
				display: "flex",
				alignItems: "center",
				width: "100%",
				justifyContent: "center",
				fontSize: 18,
				fontWeight: 600,
				color: theme.palette.primary.contrastText,
				padding: "16px 0px"
			},
			iconGoBack: {
				position: "absolute",
				left: 0,
				cursor: "pointer",
				"&:active": {
					opacity: 0.7
				}
			},
			wrapper: {
				position: "relative",
				marginTop: 50,
				backgroundColor: theme.palette.grey[600],
				borderRadius: 6,
				"& > canvas": {
					width: "100%",
					height: `calc(100vh - ${180}px)`
				}
			},
			btnSubmit: {
				background: theme.palette.primary.main,
				color: theme.palette.primary.contrastText,
				fontSize: 14,
				width: 167,
				fontWeight: 400,
				textTransform: "initial",
				"&:active": {
					color: theme.palette.common.white,
					opacity: 0.7,
					background: theme.palette.primary.main
				},
				"&:hover": {
					background: theme.palette.primary.main
				}
			},
			btnCancel: {
				color: theme.palette.primary.contrastText,
				fontSize: 14,
				width: 167,
				fontWeight: 400,
				textTransform: "initial",
				"&:hover": {
					color: theme.palette.primary.contrastText
				}
			}
		}),
	{
		name: "SignaturePage",
		index: 1
	}
);

export default useStyles;
